var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollboxWrapper",
      staticClass: "knowledge-detail-box",
      class: {
        "box-overflow-hidden": _vm.callQuitWarning || _vm.callCommentInput
      }
    },
    [
      _vm.ajaxDone
        ? _c(
            "div",
            { ref: "scrollBox", staticClass: "knowledge-detail-wrapper" },
            [
              _c("div", { staticClass: "knowledge-detail" }, [
                _c("div", { staticClass: "knowledge-head" }, [
                  _c("div", { staticClass: "k-type" }, [_vm._v("知识点")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "k-title" }, [
                    _vm._v(_vm._s(_vm.knowledgeInfo.Title))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "knowledge-content padding-sets" }, [
                  _c("div", { staticClass: "k-author flexBox" }, [
                    _c("img", {
                      staticClass: "avator",
                      attrs: { src: "" + _vm.knowledgeInfo.HeadPic },
                      on: { error: _vm.$imgErr }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "flexItem" }, [
                      _c("p", {
                        staticClass: "k-author-name",
                        domProps: {
                          textContent: _vm._s(
                            (_vm.knowledgeInfo.OwnerEngName || " ") +
                              " " +
                              (_vm.knowledgeInfo.OwnerName || "")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "k-update-last" }, [
                        _vm._v(
                          "更新于" +
                            _vm._s(
                              _vm._f("timeAgo")(_vm.knowledgeInfo.UpdatedOn)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { staticClass: "k-enterprise-wechat" },
                      [
                        _c("img", {
                          staticClass: "tel",
                          attrs: { src: "/static/images/call-qywx.png" },
                          on: {
                            click: function($event) {
                              return _vm.actionEnterpriseChat(
                                _vm.knowledgeInfo.Title,
                                _vm.knowledgeInfo.OwnerEngName +
                                  " " +
                                  _vm.knowledgeInfo.OwnerName,
                                _vm.knowledgeInfo.ChatList
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "opacity-fade" } }, [
                          _vm.tooltipShow
                            ? _c(
                                "div",
                                {
                                  staticClass: "tooltip-wrap",
                                  on: { click: _vm.setTooltipRead }
                                },
                                [
                                  _c("span", { staticClass: "tooltip" }, [
                                    _vm._v("我是知识负责人，可以找我私聊"),
                                    _c("i", { staticClass: "k-close" }, [
                                      _vm._v("✕")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bottom-trangle" })
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    ref: "kMaintain",
                    staticClass: "k-maintain",
                    class: [
                      _vm.$style["k-maintain"],
                      ((_obj = {}),
                      (_obj[_vm.$style["k-maintain-font-reset"]] =
                        _vm.resetClass),
                      _obj)
                    ],
                    domProps: { innerHTML: _vm._s(_vm.knowledgeInfo.PlainText) }
                  }),
                  _vm._v(" "),
                  _vm.sourceList.length
                    ? _c(
                        "div",
                        { ref: "ksource", staticClass: "k-source flexBox" },
                        _vm._l(_vm.sourceList, function(img, index) {
                          return _c(
                            "picture",
                            {
                              staticClass: "picture",
                              on: {
                                click: function($event) {
                                  return _vm.previewImg(img.src, index)
                                }
                              }
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index < 4,
                                    expression: "index < 4"
                                  }
                                ],
                                staticClass: "img-loaded source-img",
                                attrs: { src: img.ThumbUrl }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                staticClass: "img-loaded-detect",
                                attrs: { src: img.ThumbUrl },
                                on: { load: _vm.$placeImg }
                              }),
                              _vm._v(" "),
                              _vm.sourceList.length > 4 && index === 3
                                ? [
                                    _vm.sourceList.length > 4 && index === 3
                                      ? _c("div", { staticClass: "barrage" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "barrage-text" }, [
                                      _c(
                                        "span",
                                        { staticClass: "barrage-text-plus" },
                                        [_vm._v("+")]
                                      ),
                                      _vm._v(
                                        _vm._s(_vm.sourceList.length - 4) +
                                          "\n                            "
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.videoList.length
                    ? _c(
                        "div",
                        { staticClass: "k-video" },
                        _vm._l(_vm.videoList, function(video, index) {
                          return _c(
                            "p",
                            {
                              staticClass: "video flexBox",
                              on: {
                                click: function($event) {
                                  return _vm.showVideo(video.src)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "video-play" }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(video.FileName)
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "video-download",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadVideo(video)
                                  }
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.attachmentList.length
                    ? _c(
                        "div",
                        { staticClass: "k-attachment" },
                        _vm._l(_vm.attachmentList, function(attachment) {
                          return _c(
                            "div",
                            {
                              staticClass: "attachment flexBox",
                              on: {
                                click: function($event) {
                                  return _vm.openFile(
                                    attachment.src,
                                    attachment.FileType,
                                    attachment.FileName,
                                    attachment.Slug
                                  )
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "attachment-link" }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(attachment.FileName)
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.knowledgeInfo.Tags && _vm.knowledgeInfo.Tags.length
                    ? _c(
                        "div",
                        { staticClass: "k-tag flexBox" },
                        _vm._l(_vm.knowledgeInfo.Tags, function(tag) {
                          return _c("p", { staticClass: "tag" }, [
                            _c("span", {
                              domProps: { textContent: _vm._s(tag.title) }
                            })
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "k-view-count" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("validCount")(_vm.knowledgeInfo.TotalViewCount)
                        ) + "人浏览"
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.FIList.length,
                      expression: "FIList.length"
                    }
                  ],
                  staticClass: "knowledge-recommend padding-sets"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "recommend-lists recommend-interest-lists" },
                    _vm._l(_vm.FIList, function(interest) {
                      return _c("section", {
                        staticClass: "recommend-list",
                        domProps: { textContent: _vm._s(interest.Title) },
                        on: {
                          click: function($event) {
                            return _vm.viewFaq(interest)
                          }
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.FIPageIndex < _vm.FIPageCount && _vm.prevAjaxEnd
                    ? _c(
                        "div",
                        {
                          staticClass: "recommend-load",
                          on: {
                            click: function($event) {
                              return _vm.loadMore()
                            }
                          }
                        },
                        [_vm._v("查看更多")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div"),
                  _vm._v(" "),
                  _vm.callRelatedFaqLoading ? _c("loading-more") : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "leave-divider" },
                [
                  _c("leave-list", {
                    attrs: {
                      commentListTitle: _vm.commentListTitle,
                      extraInfo: _vm.matchedComment,
                      commentsTotalCount: _vm.commentsTotalCount,
                      commentsForPageCount: _vm.commentsForPageCount,
                      commentsList: _vm.commentsList,
                      checkMoreComment: _vm.checkMoreComment
                    },
                    on: {
                      checkMoreCommentClick: _vm.checkMoreCommentClick,
                      deleteComment: _vm.deleteComment,
                      initCommentList: _vm.initCommentList,
                      refreshCommentList: _vm.refreshCommentList
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "knowledge-detail-btn",
                  on: { click: _vm.goTreeMenu }
                },
                [_vm._m(1)]
              ),
              _vm._v(" "),
              _vm.isShowTree ? _c("treeMenu2") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.callVideoPlayer,
                      expression: "callVideoPlayer"
                    }
                  ],
                  staticClass: "video-wrapper"
                },
                [
                  _c("div", {
                    staticClass: "video-mask",
                    on: { click: _vm.hideVideo }
                  }),
                  _vm._v(" "),
                  _c("video", {
                    ref: "videoPlayer",
                    staticClass: "video-player",
                    attrs: { src: _vm.videoUrl }
                  })
                ]
              ),
              _vm._v(" "),
              _c("water-mark", { ref: "watermark" }),
              _vm._v(" "),
              _vm.imgUrlList.length
                ? _c("photo-package", {
                    ref: "contentPreview",
                    staticClass: "content-img-preview",
                    attrs: {
                      list: _vm.imgUrlList,
                      options: _vm.options,
                      selector: ".thumb-img"
                    },
                    on: { "on-close": _vm.closeHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.sourceList.length
                ? _c("photo-package", {
                    ref: "sourcePreview",
                    attrs: {
                      list: _vm.sourceList,
                      options: _vm.options,
                      selector: ".source-img"
                    },
                    on: { "on-close": _vm.closeHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.callQuitWarning
                ? _c("quit-message", {
                    attrs: {
                      messageTitle: _vm.messageTitle,
                      messageText: _vm.messageText,
                      queryBtn: _vm.queryBtn
                    },
                    on: {
                      closeQuitWarning: _vm.closeQuitWarning,
                      eventContinue: _vm.eventContinue
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.callUnauthorize
                ? _c("unauthorize", {
                    attrs: { unauthorizeType: _vm.unauthorizeType }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("releave-recover", {
                attrs: {
                  knowledgeInfo: _vm.knowledgeInfo,
                  extraInfo: _vm.matchedComment
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "recommend-tabs flexBox" }, [
      _c("span", { staticClass: "recommend-tab" }, [_vm._v("相关常见问题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "knowledge-detail-title" }, [
      _c("i", { staticClass: "icon icon-construct-active" }),
      _vm._v(" "),
      _c("span", [_vm._v("知识目录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-286d5076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-286d5076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/knowledgeDetail.vue
// module id = FIFA
// module chunks = 2